import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import { TreeItem, SimpleTreeView } from '@mui/x-tree-view';
import { DeviceCustomContentSelection } from './selection';
const tree_item_sx = {
    '& .MuiTreeItem-content': {
        flexDirection: 'row-reverse',
    },
};
export const DeviceCustomContentSelections = memo(function DeviceCustomContentSelections(props) {
    const { data, onChange, items } = props;
    const renderTree = useCallback((item) => {
        return (_jsx(TreeItem, { sx: tree_item_sx, itemId: item.id.toString(), label: _jsx(DeviceCustomContentSelection, { item: item, items_ids: items ?? [], onTreeItemChange: onChange }), children: Array.isArray(item.options)
                ? item.options.map((item) => renderTree(item))
                : null }, item.id));
    }, [items, onChange]);
    const trees = useMemo(() => data.map((item) => Array.isArray(item.options) &&
        item.options.length > 0 && (_jsx(SimpleTreeView, { multiSelect: true, disableSelection: true, children: renderTree(item) }, item.name))), [data, renderTree]);
    return _jsx(Box, { children: trees });
});
